<img class="icon-close" (click)="close()" src="assets/icons/ico-close.png" alt="icon-close">

<div class="mt-3 container">
    <h3 mat-dialog-title class="mb-3" [innerHTML]="data.title"></h3>

    <mat-dialog-content>
        <!-- <object [data]=url></object> -->
        <ngx-extended-pdf-viewer [base64Src]="data.url" useBrowserLocale="false" [height]="'50vh'"></ngx-extended-pdf-viewer>
        <!-- <iframe  title="iframe" src={{url}}></iframe> -->
        <p class="txt-link-informativo" (click)=downloadPdf()>{{ data.download }}</p>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="close()" class="btn-primary-tbk mx-auto">{{ data.button }}</button>
    </mat-dialog-actions>
</div>
